import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <>
      <section className="chapter">
        <h3 className="chapter__title">New Innovations Bring New Challenges</h3>
        <p className="chapter__paragraph">
          As car technology advances, it creates a ripple effect throughout every portion of the
          industry. For example, as a desire for autonomous and semi-autonomous vehicles increases,
          many new cars will be equipped with LiDAR sensors, which use advanced laser scanning
          technology to map a car’s surroundings in 3D — leading to super precise and constantly
          updated images that make driver-assist systems safer and autonomous driving technology
          possible.
        </p>

        <p className="chapter__paragraph">
          But LiDAR sensors view colors in different ways — dark colors absorb more light and can be
          harder to see, while the way metallic colors change with the light can be confusing to the
          system’s lasers. All of this could lead to potential safety issues, so modern surfacing
          and manufacturing techniques will need to adapt to suit new technologies. BASF has
          foreseen the problem, and, in 2019, released “Centripetal Blue,” a blue-black color with a
          medium coarse sparkle that is LiDar-detectable.
        </p>
      </section>
    </>
  );
}

export default Chapter4;
